<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-11-20 14:37:29
 * @FilePath: /wemeet-admin-new/src/views/enterPriseConfig/components/generateWx.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
  >
    <div class="containerForm">
      <el-descriptions border :column="1" direction="vertical" :size="desSize" title="渠道码">
        <el-descriptions-item label="小程序二维码">
          <div style="display: flex">
            <div style="text-align: center">
              <el-image
                fit="cover"
                :initial-index="4"
                :src="qrCodeUrl"
                style="width: 300px; height: 300px"
                :zoom-rate="1.2"
              />
              <el-button
                v-if="!!qrCodeUrl"
                style="width: 200px; margin-top: 30px; display: block; margin: 30px auto 0 auto"
                type="primary"
                @click="downLoad(qrCodeUrl)"
              >
                下载
              </el-button>
            </div>
            <div>
              <el-image
                fit="cover"
                :initial-index="4"
                :src="qrUrl"
                style="width: 300px; height: 300px"
                :zoom-rate="1.2"
              />
              <el-button
                v-if="!!qrUrl"
                style="width: 200px; margin-top: 30px; display: block; margin: 30px auto 0 auto"
                type="primary"
                @click="downLoad(qrUrl)"
              >
                下载
              </el-button>
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="url链接">
          <span v-if="!h5Url">{{ shortLinkUrl }}</span>
          <span v-else>{{ h5Url }}</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { createQrcode, createShortLink, createPoster } from '@/api/tool'
  import { ElLoading } from 'element-plus'
  import { baseH5URL } from '@/config'
  import { getRegisterConfigList } from '@/api/channel'

  const jumpURL = baseH5URL.replace(/#$/, 'j?c=')

  export default defineComponent({
    name: 'GenerateWx',
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '40%',
        title: '链接地址',
        loading: null,
        row: {},
        qrCodeUrl: '',
        qrUrl: '',
        shortLinkUrl: '',
        desSize: 'large',
        senceKey: '',
        qrCodeParams: {},
        noQrCodeBox: false,
        website: '',
        h5Url: '',
        registerMobileUrl: [],
      })
      // 打开
      const handleOpen = (row = {}, qrCodeParams, noQrcode, h5Url) => {
        state.row = row
        state.dialogFormVisible = true
        state.qrCodeParams = qrCodeParams
        state.loading = ElLoading.service({
          lock: true,
          text: '二维码链接正在生成中，请稍候',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        if (noQrcode) {
          state.noQrCodeBox = true
          state.website = `${baseH5URL}/formData?code=${row.code}`
          state.loading.close()
        } else {
          // 判断是否有定制的 url
          state.h5Url = h5Url
          shortLink()
        }
        // generateMobileUrl()
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
        state.qrCodeUrl = ''
        state.qrUrl = ''
        state.senceKey = ''
        state.shortLinkUrl = ''
      }
      const checkAppkey = () => {
        let customInfo = localStorage.getItem('customInfo')
        let tenantKey = ''
        if (customInfo != 'null' && customInfo != 'undefined') {
          customInfo = JSON.parse(customInfo)
          if (customInfo.tenantKey) {
            tenantKey = customInfo.tenantKey
          } else {
            tenantKey = ''
          }
        }
        return tenantKey
      }

      const shortLink = async (row) => {
        console.log(checkAppkey())
        const tenantKey = checkAppkey()
        let logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetMiniLogo.png'
        if (tenantKey == 'MEETSG') {
          logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/meetSgQrcodeIcon.png'
        } else if (tenantKey == 'MEHZ') {
          logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/mehzQrcodeIcon.png'
        } else {
          logo = 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetMiniLogo.png'
        }
        createQrcode(state.qrCodeParams)
          .then(async (res) => {
            const linkParams = {
              pageTitle: 'sence跳转',
              params: `{"scene":"${res.data.scenesKey}"}`,
              path: '/pages/index/index',
              type: 'HOMEPAGE',
            }
            state.qrUrl = res.data.value
            const url = `${baseH5URL}/qrCodeByIcon?logo=${logo}&qrCodeUrl=${res.data.value}`
            const data = {
              url,
              width: 750,
              height: 750,
            }

            const { data: value } = await createPoster(data)
            state.qrCodeUrl = value
            state.senceKey = res.data.scenesKey
            createShortLink(linkParams)
              .then((resp) => {
                state.loading.close()
                console.log(resp)
                state.shortLinkUrl = jumpURL + resp.data
              })
              .catch((err) => {
                state.loading.close()
                handleClose()
                proxy.$baseMessage(`生成失败`, 'error', 'vab-hey-message-error')
              })
          })
          .catch((err) => {
            state.loading.close()
            handleClose()
            proxy.$baseMessage(`生成失败`, 'error', 'vab-hey-message-error')
          })
      }

      const downLoad = (url) => {
        var image = new Image()
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function () {
          var canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          var context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          var url = canvas.toDataURL('image/jpg') //得到图片的base64编码数据
          var a = document.createElement('a') // 生成一个a元素
          var event = new MouseEvent('click') // 创建一个单击事件
          console.log(proxy)
          a.download = state.row.meetingName ? `${state.row.meetingName}.jpeg` : '小程序二维码.jpeg' // 设置图片名称
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
        }
        image.src = url
      }

      const generateMobileUrl = async () => {
        getRegisterConfigList(state.row.code).then((res) => {
          state.registerMobileUrl = res.data
          state.registerMobileUrl.forEach((v) => {
            v.h5Url = `${baseH5URL}/applyForm?identity=${v.identity}&meetingCode=${v.meetingCode}&meetingType=${
              v.meetingType
            }&language=${v.identity == 'AUDIENCE_EN' ? 'EN' : 'CN'}`
          })
          console.log(state.registerMobileUrl)
        })

        // state.aiUrl = `${baseH5URL}/`
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        shortLink,
        downLoad,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
</style>
